import { types } from 'mobx-state-tree';

const File = types.model('File', {
  serverUrl: types.string,
  blobUrl: types.string,
  compressed: types.boolean,
});

const FilesStore = types
  .model('FilesStore', {
    cashFiles: types.array(File),
  })
  .actions((self) => {
    const clearFiles = () => {
      self.cashFiles.clear();
    };
    const addFile = (file: {
      serverUrl: string;
      blobUrl: string;
      compressed: boolean;
    }) => {
      self.cashFiles.push(file);
    };
    const getFile = (serverUrl: string, compressed: boolean) => {
      return self.cashFiles.find(
        (file) => file.serverUrl === serverUrl && file.compressed === compressed
      );
    };
    return {
      clearFiles,
      addFile,
      getFile,
    };
  });

export default FilesStore;
